import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/app/shell/Sidebar';
import { Header } from '@/app/shell/Header';
import { ThemeSwitcherPanel } from '@/app/shell/ThemeSwitcherPanel';
import { ToastViewport } from '@/components/ui/Toast';
import { PORTAL_NAV_SECTIONS } from '@/app/navigation/portalNav.config';
import { usePortalSummary } from '@/lib/api/queries';

/**
 * KİRACI PORTALI KABUĞU.
 *
 * YÖNETİM ARAYÜZÜYLE AYNI KABUK — AYRI BİR TASARIM DEĞİL.
 *
 * Önce portal için mobil öncelikli ayrı bir düzen (alt sekme çubuğu, dar
 * tek sütun) yazılmıştı. İki ayrı tasarım iki ayrı bakım yükü demektir:
 * bir bileşen düzeltildiğinde diğerinde geride kalır, tema değişikliği
 * yalnızca bir tarafa uygulanır ve zamanla iki arayüz "aynı ürünün iki
 * parçası" gibi görünmemeye başlar. Kiracı da AVM müdürüyle aynı ürünü
 * kullanıyor; farklı olan YETKİSİ, tasarım dili değil.
 *
 * Mobil uyum aynı kabuğun içinde çözülür: sol menü 992px altında kayan
 * panele (offcanvas) dönüşür, sayfa içerikleri Bootstrap ızgarasıyla tek
 * sütuna iner. Kiracı ciroyu mağazadan telefonla beyan edebilir — ama
 * bunun için ayrı bir arayüze değil, duyarlı bir arayüze ihtiyaç var.
 *
 * GÜVENLİK TARAFI DEĞİŞMEZ: rota ağacı hâlâ ayrıdır ve `RequireUserType`
 * ile korunur; sunucuda `@TenantOnly` personel token'ını bu uçlara hiç
 * sokmaz. Paylaşılan olan görünüm katmanıdır, veri yolu değil.
 */
export function TenantPortalLayout() {
  const [themePanelOpen, setThemePanelOpen] = useState(false);

  /**
   * Başlıktaki kiracı bilgisi, içerikle AYNI kaynaktan gelir.
   *
   * Başlığı `/auth/me`'den, içeriği `/portal/summary`'den beslemek iki ayrı
   * doğruluk kaynağı demektir; ikisi bir an bile ayrışsa kiracı
   * "başkasının verisini görüyorum" diye düşünür — ve portalda bu şüphe,
   * yanlış bir rakamdan daha pahalıdır.
   */
  const summary = usePortalSummary();
  const tenant = summary.data?.tenant;
  const leases = summary.data?.leases ?? [];
  const primary = leases[0];

  const subtitle =
    leases.length > 1
      ? `${leases.length} mağaza`
      : primary
        ? `${primary.mallName} · Ünite ${primary.unitCode}`
        : undefined;

  return (
    <div className="app-shell">
      {/* Klavye kullanıcıları menüyü her sayfada baştan geçmek zorunda kalmasın. */}
      <a className="skip-link" href="#main-content">
        İçeriğe atla
      </a>

      <Sidebar sections={PORTAL_NAV_SECTIONS} />

      <div className="app-content">
        <Header
          variant="portal"
          context={{ title: tenant?.brandName ?? 'Kiracı Portalı', ...(subtitle ? { subtitle } : {}) }}
          onOpenThemePanel={() => setThemePanelOpen(true)}
        />

        <main id="main-content">
          <Outlet />
        </main>

        <footer className="app-footer">
          <div className="d-flex flex-wrap justify-content-between gap-2">
            <span>© {new Date().getFullYear()} MallOS — Apex Technology</span>
            <span className="text-muted">Kiracı Portalı</span>
          </div>
        </footer>
      </div>

      <ThemeSwitcherPanel show={themePanelOpen} onHide={() => setThemePanelOpen(false)} />

      <ToastViewport />
    </div>
  );
}
